import { Button } from "@datapay-by-datacom/design-system";
import type { ErrorSummary } from "../../types";
import { formatNumber, formatPercentage } from "../../utils/formatters";
import styles from "./ErrorSummaryPanel.module.css";

export interface ErrorSummaryPanelProps {
  errorSummary: ErrorSummary;
  onManageDlq?: () => void;
}

export function ErrorSummaryPanel({
  errorSummary,
  onManageDlq,
}: ErrorSummaryPanelProps) {
  const { dlq_count, error_rate_by_type } = errorSummary;

  return (
    <div className={styles.container} data-testid="error-summary-panel">
      <div
        className={dlq_count > 0 ? styles.dlqWarning : styles.dlqNeutral}
        data-testid="dlq-count"
      >
        <span className={styles.dlqLabel}>Dead Letter Queue</span>
        <span className={styles.dlqValue}>{formatNumber(dlq_count)}</span>
        {dlq_count > 0 && onManageDlq && (
          <Button variant="secondary" size="small" onPress={onManageDlq}>
            Manage DLQ
          </Button>
        )}
      </div>

      {error_rate_by_type.length > 0 && (
        <table className={styles.table} data-testid="error-type-table">
          <thead>
            <tr>
              <th className={styles.headerCell}>Error Type</th>
              <th className={styles.headerCell}>Count</th>
              <th className={styles.headerCell}>Percentage</th>
            </tr>
          </thead>
          <tbody>
            {error_rate_by_type.map((entry) => (
              <tr key={entry.error_type}>
                <td className={styles.cell}>{entry.error_type}</td>
                <td className={styles.cellNumeric}>
                  {formatNumber(entry.count)}
                </td>
                <td className={styles.cellNumeric}>
                  {formatPercentage(entry.percentage)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {error_rate_by_type.length === 0 && dlq_count === 0 && (
        <p className={styles.noErrors}>No errors recorded.</p>
      )}
    </div>
  );
}
